import React, { useEffect } from "react";
import './about.scss'
import ScrollReveal from 'scrollreveal';


export default function About (){
    useEffect(() => {
        ScrollReveal().reveal('.reveal', {
        });
      }, []); 
    const works = [
        {
            company: "Gislen Software",
            position: "Software Engineer",
            startDate: new Date(2023, 3),  // Month is 0-indexed, so April is 3
            endDate: new Date(),          // Current date
            place: "Chennai, TamilNadu ,India",
        },
        {
            company: "Gislen Software",
            position: "Software Engineer Trainee",
            startDate: new Date(2022, 6),  // Month is 0-indexed, so July is 6
            endDate: new Date(2023, 2),    // Month is 0-indexed, so March is 2
            place: "Chennai, TamilNadu ,India"
        }
    ];
    
    // Function to calculate the difference in years and months
    function dateDifference(startDate, endDate) {
        let years = endDate.getFullYear() - startDate.getFullYear();
        let months = endDate.getMonth() - startDate.getMonth();
    
        if (months < 0) {
            years--;
            months += 12;
        }
    
       return formate(years,months)
    }
    
    function formate(totalYears,remainingMonths){
        return totalYears > 0 ? ( remainingMonths > 0? `${totalYears} yrs ${remainingMonths} mos`:`${totalYears} yrs` ): `${remainingMonths} mos`;
   
    }
    
    // Function to calculate the total duration for a company
    function calculateTotalDuration(entries) {
        let totalMonths = 0;
        
        entries.forEach(entry => {
            const start = new Date(entry.startDate);
            const end = new Date(entry.endDate);
            
            let years = end.getFullYear() - start.getFullYear();
            let months = end.getMonth() - start.getMonth();
    
            if (months < 0) {
                years--;
                months += 12;
            }
    
            totalMonths += years * 12 + months;
        });
    
        const totalYears = Math.floor(totalMonths / 12);
        const remainingMonths = totalMonths % 12;
    
       return formate(totalYears,remainingMonths)
    }
    
    // Group by company and calculate total duration within the key
    const groupedByCompany = works.reduce((acc, work) => {
        if (!acc[work.company]) {
            acc[work.company] = {
                totalDuration: '',
                positions: [],
                place:work.place
            };
        }
        const duration = dateDifference(work.startDate, work.endDate);

 
        acc[work.company].positions.push({
            position: work.position,
            startDate: work.startDate,
            endDate: work.endDate,
            duration:duration
        });

    
        // Calculate the total duration for the company so far
        acc[work.company].totalDuration = calculateTotalDuration(acc[work.company].positions);
    
        return acc;
    }, {});
    const groupedArray = Object.entries(groupedByCompany);
         const formatDate = (date) => {
            if(date.toDateString()===new Date().toDateString()){
                return "Present"
            }
            return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long' });
          };
    
return(
<div className="about">
    <div className="container-1">
<span className="heading">About {'(Education & Work)'}</span>
<div className="container">
    <div className="work">

        <div className="heading-text work-heading">Experience</div>
       <div className="grid-contain">
       <div className="vertical-line">  
       </div>
    
        <div className="work-contianer">
        {groupedArray.map(([company, { totalDuration, positions ,place}], index) => (
             <div className="contant" key={index}>
                <div className="bold company-name">
                    {company}
                </div>
                <div className="medium year-experience">
                   {totalDuration}
                </div>
                <div className="light location">
                   {place} 
                </div>
                {positions.map((position,posIndex)=>(
               <div className="positon" key={posIndex}>
                <div className="bold position-name">
                    {position.position}
                </div>
                <span>Full-time</span>
                <div className="light time-line ">
                    {formatDate(position.startDate)} - {formatDate(position.endDate)} <span className="dot">.</span> {position.duration}
                </div>
               </div>))}
            </div>
            )
            )}
          
        </div>   </div>
    </div>
    <div className="education">
    <div className="heading-text education-heading">Education</div>
    <div className="education-content">
                <div className="bold collageName">
                    Jeppiar SRR Engineering collage 
                </div>
                <div className="light batch">
                    2018 - 2022 Batch
                </div>
                <div className="bold department">
                Bachelor of Engineering (Computer Science)  
                 </div>
                 <div className="light location">
                Padur, Chennai -603 103
                </div></div>
                </div>
             
</div></div>
<div className="container-2 services">
    <span className="heading reveal">What I Do</span>
     <div className="cards">
        <div className="card reveal">
            <div className="image">
            <svg xmlns="http://www.w3.org/2000/svg" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd" viewBox="0 0 108.35 122.88">
    <path d="M0,0l9.86,110.59l44.25,12.29l44.36-12.3L108.35,0L0,0L0,0L0,0z M70.96,63.62l-1.57,17.59l-15.15,4.09 l-15.1-4.07L38.18,70.4l-13.62,0l1.9,21.3l27.85,7.7l27.76-7.7l3.72-41.64H36.36l-1.24-13.89h51.9l1.21-13.56H20.29l3.66,41.02 L70.96,63.62L70.96,63.62z M90.02,103.54l-35.66,9.88v0.05l-0.09-0.03l-0.09,0.03v-0.05l-35.66-9.88L10.08,9.05h88.38L90.02,103.54 L90.02,103.54z"/>
</svg>

</div>
            <div className="name ">
                Front End Development
            </div>

            <div className="content ">
            I create user-centric, responsive designs and collaborate closely with teams to ensure high-quality results. I prioritize clean, maintainable code and stay updated with the latest technologies. Using agile practices, I iterate based on feedback to continuously optimize performance.
            </div>

        </div>
        <div className="card reveal">
            <div className="image">

<svg xmlns="http://www.w3.org/2000/svg" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd" viewBox="0 0 512 377.51"><path d="M32.001 0h408.722c17.6 0 32.001 14.401 32.001 32.001v96.212a587.863 587.863 0 00-19.029-2.981V89.6h.137H20.337v232.588a8.75 8.75 0 002.589 6.269 8.752 8.752 0 006.269 2.589h259.282c1.864 6.822 4.2 13.506 7.095 20.025H32.001C14.401 351.071 0 336.67 0 319.07V32.001C0 14.401 14.401 0 32.001 0zm329.921 204.736c14.914 4.98 35.672 8.058 58.732 8.058 23.061 0 43.817-3.078 58.733-8.058 13.091-4.369 21.188-9.66 21.188-14.836 0-5.172-8.097-10.463-21.188-14.833-14.916-4.979-35.672-8.06-58.733-8.06-23.06 0-43.818 3.081-58.732 8.06-27.776 9.271-28.539 20.143 0 29.669zm111.97 24.189c4.934 0 8.936 4.001 8.936 8.935s-4.002 8.933-8.936 8.933a8.932 8.932 0 01-8.933-8.933c0-4.934 3.999-8.935 8.933-8.935zm0 52.598c4.934 0 8.936 4.002 8.936 8.935 0 4.934-4.002 8.933-8.936 8.933a8.932 8.932 0 01-8.933-8.933c0-4.933 3.999-8.935 8.933-8.935zm0 50.503a8.938 8.938 0 018.936 8.936c0 4.934-4.002 8.933-8.936 8.933a8.932 8.932 0 01-8.933-8.933c0-4.934 3.999-8.936 8.933-8.936zm26.713-21.846c-4.663 3.191-10.601 6.003-17.624 8.347-16.064 5.364-38.111 8.681-62.327 8.681-24.217 0-46.262-3.317-62.328-8.681-6.932-2.315-12.838-5.084-17.474-8.223v34.029c1.031 4.826 8.888 9.69 21.07 13.756 14.914 4.977 35.672 8.057 58.732 8.057 23.061 0 43.817-3.078 58.733-8.057 9.04-3.019 15.698-6.476 18.954-10.029 2.686-2.933 2.264-4.866 2.264-8.371V310.18zM329.37 189.9c0-10.606 11.066-19.603 28.956-25.576 16.066-5.361 38.114-8.681 62.328-8.681 24.216 0 46.263 3.32 62.329 8.681 16.284 5.436 26.914 13.38 28.69 22.762.212.596.327 1.238.327 1.909v156.608c0 10.858-20.742 20.466-29.019 23.227-16.064 5.363-38.111 8.68-62.327 8.68-24.217 0-46.262-3.317-62.328-8.68-8.471-2.829-28.837-12.119-28.837-23.227v-3.639c0-50.686-.119-101.383-.119-152.064zm11.482 104.13c1.031 4.824 8.888 9.688 21.07 13.754 14.914 4.98 35.672 8.06 58.732 8.06 23.061 0 43.817-3.08 58.733-8.06 13.091-4.369 21.188-9.66 21.188-14.833h.062v-33.073c-4.663 3.191-10.633 6-17.656 8.345-16.064 5.364-38.111 8.68-62.327 8.68-24.217 0-46.262-3.316-62.328-8.68-6.932-2.313-12.838-5.082-17.474-8.221v34.028zm0-50.304c1.031 4.826 8.888 9.69 21.07 13.756 14.914 4.977 35.672 8.058 58.732 8.058 23.061 0 43.817-3.078 58.733-8.058 13.091-4.369 21.188-9.66 21.188-14.836h.062v-35.514c-4.663 3.191-10.633 6.003-17.656 8.345-16.064 5.364-38.111 8.68-62.327 8.68-24.214 0-46.262-3.316-62.328-8.68-6.932-2.313-12.838-5.082-17.474-8.221v36.47zm-208.478-13.883c4.338 3.795 4.775 10.394.98 14.731-3.795 4.338-10.393 4.776-14.731.981l-39.691-34.778c-4.337-3.795-4.775-10.394-.98-14.732a10.46 10.46 0 011.064-1.053l39.607-34.703c4.338-3.795 10.936-3.357 14.731.981s3.358 10.936-.98 14.731l-30.725 26.92 30.725 26.922zm84.685 15.712c-4.337 3.795-10.936 3.357-14.731-.981-3.795-4.337-3.357-10.936.98-14.731l30.725-26.922-30.725-26.92c-4.337-3.795-4.775-10.393-.98-14.731 3.795-4.338 10.394-4.776 14.731-.981l39.607 34.703c.374.32.731.672 1.064 1.053 3.795 4.338 3.357 10.937-.98 14.732l-39.691 34.778zm-45.317-99.492c1.378-5.605 7.04-9.032 12.645-7.654 5.605 1.377 9.032 7.039 7.654 12.644l-25.577 102.935c-1.377 5.606-7.039 9.032-12.644 7.655-5.605-1.378-9.032-7.04-7.655-12.645l25.577-102.935zm238.524-110.09c8.729 0 15.806 7.077 15.806 15.806s-7.077 15.803-15.806 15.803-15.806-7.074-15.806-15.803c0-8.729 7.077-15.806 15.806-15.806zm-107.128 0c8.729 0 15.806 7.077 15.806 15.806s-7.077 15.803-15.806 15.803c-8.728 0-15.805-7.074-15.805-15.803 0-8.729 7.077-15.806 15.805-15.806zm53.566 0c8.728 0 15.803 7.077 15.803 15.806s-7.075 15.803-15.803 15.803c-8.729 0-15.806-7.074-15.806-15.803 0-8.729 7.077-15.806 15.806-15.806z"/></svg>            </div>
            <div className="name ">
                Back End Development
            </div>

            <div className="content ">
            I develop scalable and reliable backend systems, focusing on clean code and optimal database performance. I stay updated with the latest technologies and use agile practices to iterate based on feedback, ensuring robust and efficient solutions.            </div>

        </div>  <div className="card reveal">
            <div className="image">
            <svg xmlns="http://www.w3.org/2000/svg" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd" viewBox="0 0 512 511.97"><path fill-rule="nonzero" d="M23.77 0h185.92c13.09 0 23.77 10.69 23.77 23.77v185.92c0 13.02-10.75 23.77-23.77 23.77H23.77C10.72 233.46 0 222.74 0 209.69V23.77C0 10.65 10.65 0 23.77 0zM302.3 278.5h185.93c13.02 0 23.77 10.75 23.77 23.77V488.2c0 13-10.78 23.77-23.77 23.77H302.3c-6.5 0-12.45-2.69-16.75-6.97-4.33-4.37-7.02-10.31-7.02-16.8V302.27c0-13.12 10.65-23.77 23.77-23.77zm181.91 27.78h-177.9v177.9h177.9v-177.9zM302.3 0h185.93C501.25 0 512 10.75 512 23.77v185.92c0 13.02-10.75 23.77-23.77 23.77H302.3c-13.05 0-23.77-10.72-23.77-23.77V23.77C278.53 10.65 289.18 0 302.3 0zm181.91 27.79h-177.9v177.88h177.9V27.79zM23.77 278.5h185.92c13.09 0 23.77 10.68 23.77 23.77V488.2c0 13.01-10.75 23.77-23.77 23.77H23.77C10.75 511.97 0 501.21 0 488.2V302.27c0-13.12 10.65-23.77 23.77-23.77zm181.9 27.78H27.79v177.9h177.88v-177.9zm0-278.49H27.79v177.88h177.88V27.79z"/></svg>
           </div>
            <div className="name ">
                UI Design
            </div>

            <div className="content ">
            As a beginner with a strong passion for UI design, I’m eager to learn and create engaging, user-friendly interfaces. I’m focused on developing my skills by staying updated with design trends and practicing responsive design principles. 
</div>
        </div>
        </div>       

</div>
</div>);


}